export class OAuthTokenRequest {
	refreshToken: string;

	constructor() {
		this.refreshToken = '';
	}
}
